export class AiShoppableImageError extends Error {}
